<template>
  <div>
    <h2>我的考试</h2>
    <a-divider></a-divider>
    <a-card class="search-card" :bordered="false">
      <!-- <a-radio-group buttonStyle="solid" @change="getPaperList" v-model="queryParam.isSimulation">
        <a-radio-button :value="1"> 模拟卷 </a-radio-button>
        <a-radio-button :value="0"> 正式卷 </a-radio-button>
      </a-radio-group>
      <a-divider type="vertical"/>
      <j-dict-select-tag
        style="width:200px"
        @change="handleChangeType"
        v-model="queryParam.paperType"
        :trigger-change="true"
        dictCode="paper_type"
      /> -->
      <a-button icon="right-circle" type="danger" @click="toMyPaperAnswer">查看我的答卷</a-button>
      <a-divider type="vertical"></a-divider>
      <a-button type="primary" @click="envCheck()" icon="camera" id="envCheckBtn">设备检测</a-button>
      <br><br>
      <!-- <a-divider /> -->
      <!-- <a-list :dataSource="paperDataSource" :pagination="pagination">
        <a-list-item slot="renderItem" slot-scope="item">
          <h3>
            <a-tag v-if="item.paperType_dictText">{{ item.paperType_dictText }}</a-tag>{{ item.examName || item.paperName }}
          </h3>
          <div slot="actions">
            <a-button type="primary"  @click="toPaper(item)">
              <span>{{$t('exam.toExam')}}</span>
              <a-icon type="right"/>
            </a-button>
          </div>
        </a-list-item>
      </a-list> -->
      <a-table
        class="j-table-force-nowrap"
        :scroll="{x:true}"
        ref="table"
        bordered
        size="middle"
        rowKey="id"
        :columns="columns"
        :dataSource="paperDataSource"
        :pagination="pagination"
        :loading="loading"
      >
        <span slot="openMethod" slot-scope="text,record">
          <span v-if="text==1">长期有效</span>
          <span v-if="text==2">{{record.startTime +" - "+ record.endTime}}</span>
          <a-tooltip v-if="text==3">
            <template slot="title">
              <p>试卷：{{record.unlockPaperDeptId_dictText}}</p>
              <p>分数：{{record.unlockScore}}</p>
            </template>
            <span>通过上一级别</span>
          </a-tooltip>
        </span>
        <span slot="action" slot-scope="text, record">
          <!-- <a-button type="primary"  @click="toPaper(record)">
              <span>{{$t('exam.toExam')}}</span>
              <a-icon type="right"/>
            </a-button> -->
            <a-button type="primary" :disabled="!record.isOpen && (record.submitTimesLimit==-1 || record.submitTimesLimit>record.mySubmitTimes)" @click="toPaper(record)">
            <span>{{ $t('exam.toExam') }}</span>
            <a-icon type="right" />
          </a-button>
          <!-- <a-divider v-if="record.lotteryId" type="vertical" />
          <a-button v-if="record.lotteryId"   @click="toLottery(record)">去抽奖</a-button> -->
        </span>
      </a-table>
    </a-card>
     <ExamEnvCheckModal ref="envCheck"/>
    <LuckyGridPage v-if="luckyStatus" :luckyInfo="luckyInfo" @closeFn="luckyStatus=false" />
  </div>
</template>

<script>
import { JeecgListMixin } from "@/utils/JeecgListMixin";
import { getAction } from "@/api/manage";
import JDictSelectTag from "@/components/jeecg/JDictSelectTag";
import LuckyGridPage from '@/components/lottery/LuckyGridPage.vue';
import ExamEnvCheckModal from "@/components/exam/ExamEnvCheckModal"
export default {
  name: "Question",
  mixins: [JeecgListMixin],
  components: {
    JDictSelectTag,
    LuckyGridPage,
    ExamEnvCheckModal
  },
  data() {
    return {
      luckyStatus:false,
      luckyInfo:{},
      paperDataSource: [],
      columns: [
        {
            title:'试卷库',
            align:"center",
            dataIndex: 'paperType_dictText',
            width: 120,
        },
        {
          title:'试卷名',
          align:"center",
          dataIndex: 'paperName',
          customRender(v, r){
            return r.examName || r.paperName
          }
        },
        {
            title:'班级',
            align:"center",
            dataIndex: 'departId_dictText',
            width: 120,
        },
        {
            title:'开放时间',
            align:"center",
            dataIndex: 'openMethod',
            width: 180,
            scopedSlots: { customRender: "openMethod" },
            // customRender(v, r){
            //   if(v == 1){
            //     return "长期有效"
            //   }else if(v==2){
            //     return r.startTime.split(" ")[0] +" - "+ r.endTime.split(" ")[0]
            //   }else if(v==3){
            //     return '通过上一级别（' + r.unlockScore + '）分'
            //   }
            // }
          },
        // {
        //     title:'来源',
        //     align:"center",
        //     dataIndex: 'paperType_dictText',
        //   },
        {
          title: "操作",
          dataIndex: "action",
          fixed: "right",
          align: "center",
          // width: 240,
          scopedSlots: { customRender: "action" },
        },
      ],
      pagination: {
        onChange: (page) => {
          this.pagination.current = page
        },
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + "-" + range[1] + " 共" + total + "条"
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      loading: true,
      queryParam: {
        isSimulation: undefined,
        paperType: undefined,
        userPaperStatus: '',
      },
      disableMixinCreated: true
    }
  },
  created() {
    this.getPaperList()
  },
  methods: {
    envCheck(){
      this.$refs.envCheck.open()
    },
    // 去抽奖
    toLottery(row){
      this.luckyInfo = row
      this.luckyStatus = true
    },
     handleChangeType(v) {
      this.queryParam.paperType = v
      this.getPaperList()
    },
    handleChangeStatus(v) {
      this.queryParam.userPaperStatus = v
      this.getPaperList()
    },
    getPaperList() {
      this.loading = true
      this.paperDataSource = []
      getAction('/teaching/teachingPaper/minePaperList', {
        isSimulation: this.queryParam.isSimulation,
        paperType: this.queryParam.paperType,
        userPaperStatus: this.queryParam.userPaperStatus,
        pageSize: 999,
      }).then((res) => {
        console.log(res)
        if (res.success) {
          for(let i in res.result){
            let p = res.result[i]
          }
          this.paperDataSource = res.result
          this.pagination.total = res.result.length
        }
        this.loading = false
      })
    },
    getUserPaperStatus(status) {
      console.log(status);
      if (status == null) {
        return ['gray', this.$t('exam.noAnswer')]
      }
      if (status == 0) {
        return ['orange', this.$t('exam.saved')]
      }
      if (status == 1) {
        return ['green', this.$t('exam.nosubmittedAnswer')]
      }
      if (status == 3) {
        return ['blue', this.$t('exam.Corrected')]
      }
      return ['gray', status]
    },
    toPaper(info) {
      let route = this.$router.resolve({
        path: '/examine',
        query: {
          id: info.paperId,
          departId: info.departId,
          paperId: info.paperId
        },
      });
      window.open(route.href, '_blank')
    },
    toMyPaperAnswer(){
      this.$router.push({
        name: 'myPaperAnswer'
      })
    }
  },
};
</script>

<style>
</style>